import React from 'react'
import { Icon } from './QuizList.elements'

type Props = {
    className?: string
}

export const BadgeBorderedIcon = ({ className }: Props) => (
    <Icon
        aria-hidden
        className={className}
        fill="none"
        focusable={false}
        role="img"
        viewBox="0 0 30 30"
    >
        <path d="M29 0.5H1C0.723858 0.5 0.5 0.723858 0.5 1V29C0.5 29.2761 0.723858 29.5 1 29.5H29C29.2761 29.5 29.5 29.2761 29.5 29V1C29.5 0.723858 29.2761 0.5 29 0.5Z" stroke="black"/>
        <path d="M22 11.7296L15 8L8 11.7296C8.01892 14.533 8.65762 18.3573 11.5344 20.9325C13.1253 22.3565 14.7241 22.9346 14.9998 23C15.2759 22.9342 16.8904 22.3496 18.4826 20.9172C20.7592 18.8692 21.9741 15.6941 22 11.7296Z" fill="#4CA9ED"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M15 6L6 10.7004C6 22.9617 15 25 15 25C15 25 24 22.9617 24 10.7004L15 6ZM15 7.10198L23.0188 11.2899C22.9081 15.7587 21.5305 19.2443 18.9193 21.6565C17.2631 23.1864 15.5788 23.8058 14.9977 23.9859C14.4244 23.8108 12.7996 23.2172 11.1534 21.7231C8.49497 19.31 7.09274 15.802 6.98123 11.2901L15 7.10198Z" fill="#4CA9ED"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M14.584 16.3469H15.4678V13.1758H14.584V16.3469Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M12.1191 13.1758H13.003V15.5922H14.2521V16.3469H12.1191V13.1758Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M18.5938 13.1758H20.7224V13.9307H19.4236V14.4085H20.4381V15.1321H19.4236V15.5922H20.8169V16.3469H18.5938V13.1758Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M16.6047 13.9307H15.8066V13.1758H18.2823V13.9307H17.484V16.3469H16.6047V13.9307Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M9.52539 13.1758H11.6538V13.9307H10.355V14.4085H11.3697V15.1321H10.355V15.5922H11.7485V16.3469H9.52539V13.1758Z" fill="white"/>
    </Icon>
)
